const NS = 'BookmarkSquareWidget';
const CLS = 'bookmarkSquareWidget';

export class BookmarkSquareWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.bookmarkApi = this.$element.data('bookmarkApi');
		this.unbookmarkApi = this.$element.data('unbookmarkApi');
		this.bookmarkMessage = this.$element.data('bookmarkMessage') || 'Item Bookmarked!';
		this.id = this.$element.data('id');

		this.$element.on('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			if(this.$element.data('readonly')) {
				return;
			}

			let url;
			if(this.$element.attr('data-bookmarked') === 'true') {
				url = `${this.unbookmarkApi}?id=${this.id}`;
				$.ajax({
					type: 'POST',
					url: url,
					success: (_response, _textStatus, jqXHR) => {
						if(jqXHR.status === 204) {
							this.$element.attr('data-bookmarked', false);
						}
					}
				});
			}
			else {
				url = `${this.bookmarkApi}?id=${this.id}`;
				$.ajax({
					type: 'POST',
					url: url,
					success: (_response, _textStatus, jqXHR) => {
						if(jqXHR.status === 204) {
							this.$element.attr('data-bookmarked', true);
							this.displayBookmarkPopup();
						}
					}
				});
			}
		});
	}

	displayBookmarkPopup() {
		let $bookmarkPopup = $('.bookmarkPopup');
		if($bookmarkPopup && $bookmarkPopup.length === 0) {
			$('body').append(this.getBookmarkPopupMarkup());
			$bookmarkPopup = $('.bookmarkPopup');
			setTimeout(() => {
				$bookmarkPopup.addClass('bookmarkPopup--reveal');
			}, 50);

			// 400ms to reveal and a 5 second delay to then conceal, and a 400ms delay to remove said element.
			setTimeout(() => {
				$bookmarkPopup.removeClass('bookmarkPopup--reveal');

				setTimeout(() => {
					$bookmarkPopup.remove();
				}, 400);
			}, 3400);
		}
	}

	getBookmarkPopupMarkup() {
		return `<div class="bookmarkPopup bookmarkPopup--animate">
			<div class="bookmarkPopup-top">
				<span class="bookmarkPopup-circle">
					<i class="icon icon--tick bookmarkPopup-circle-tick"></i>
				</span>
				<span class="bookmarkPopup-title">
					${this.bookmarkMessage}
				</span>
			</div>
			<div class="bookmarkPopup-bottom">
				<button type="button" class="bookmarkPopup-button btn btn-sm btn-block">Open Dashboard</button>
			</div>
		</div>`;
	}
}
